import {
  closeAccountSettingsModal,
  openAccountSettingsModal,
} from "./account-settings";
import {
  closeMemberManagementModal,
  openMemberManagementModal,
} from "./member-management";

export {
  closeAccountSettingsModal,
  closeMemberManagementModal,
  openAccountSettingsModal,
  openMemberManagementModal,
};
declare global {
  interface Window {
    __saasbaseCoreSdk: {
      openMemberManagementModal?: () => void;
      closeMemberManagementModal?: () => void;
      openAccountSettingsModal?: () => void;
      closeAccountSettingsModal?: () => void;
    };
  }
}

// Make them available globally on the same namespace as Auth
if (typeof window !== "undefined") {
  if (!window.__saasbaseCoreSdk) {
    window.__saasbaseCoreSdk = {};
  }
  window.__saasbaseCoreSdk.openAccountSettingsModal = openAccountSettingsModal;
  window.__saasbaseCoreSdk.closeAccountSettingsModal =
    closeAccountSettingsModal;
  window.__saasbaseCoreSdk.openMemberManagementModal =
    openMemberManagementModal;
  window.__saasbaseCoreSdk.closeMemberManagementModal =
    closeMemberManagementModal;
}
